import * as Sentry from '@sentry/browser'

export const initSentry = (env) => {
  // GIT_VERSION is injected by rspack DefinePlugin as a free identifier, not on globalThis
  if (!GIT_VERSION) return
  Sentry.init({
    dsn: 'https://266f73f01f09432ebf01138bd5f050e6@o86130.ingest.sentry.io/1259170',
    release: GIT_VERSION,
    environment: env,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
    beforeSend(event) {
      console.error(event)
      if (env === 'ONPREMISE' || window.DISABLE_SENTRY) return null
      else return event
    },
  })

  window.SENTRY_INITIALIZED = true
}
